import {useOpenedStateManager} from '@aboutyou/opened-state-manager';

export const useCoinsLatestAchievementsOpenedState = () => {
  const {isOpen, open, cancel} = useOpenedStateManager(
    'coinsLatestAchievementsOpenedState',
  );

  return {
    isOpen,
    open,
    cancel,
  };
};
